<template>
  <div class="project-manager-mix">
    <div class="mix-version">
      <router-link :to="`/mixes/${mix._id}`">
        {{ project.name }} mix v{{ mix.version }}
      </router-link>
    </div>
    <div class="mix-author">
      Submitted by {{ mix.author.first_name }}
      {{ mix.author.last_name }}
    </div>
    <div class="mix-updated">updated {{ when }}</div>
  </div>
</template>

<script lang="ts">
import { timeDelta } from "@/misc";
import { Mix, Project } from "@/models";
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    project: {
      type: Object,
      required: true,
    },
    mix: {
      type: Object,
      required: true,
    },
  },
})
export default class ProjectManagerMix extends Vue {
  mix!: Mix;
  project!: Project;

  get when() {
    const updated = new Date(this.mix.updated_at);
    return timeDelta(updated);
  }
}
</script>

<style lang="scss">
.project-manager-mix {
  margin-top: 2px;
  margin-bottom: 2px;
  padding-left: 12px;
  display: flex;
  width: 100%;
  max-width: 800px;
  box-sizing: border-box;

  .mix-version {
    flex-grow: 1;
    font-weight: bold;
    a {
      color: black;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  .mix-author {
    width: 220px;
  }

  .mix-updated {
    width: 220px;
  }
}
</style>
